import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

const button: CSSProperties = {
  minWidth: "125px",
  marginLeft: "10px",
  "&:hover": {
    backgroundColor: helpers.opacity(greys.darkestGrey, 0.1),
  },
};

const rippleRoot: CSSProperties = {
  color: helpers.opacity(greys.darkestGrey, 0.3),
};

const label: CSSProperties = {
  marginBottom: -3,
};

const joined: CSSProperties = {
  marginTop: "auto",
  marginBottom: "auto",
  paddingRight: spacing.std,
  paddingLeft: spacing.std,
};

export const styles = {
  button,
  rippleRoot,
  label,
  joined,
};
